import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";
import { Button } from "@upstageai/ui";
import { useTranslation } from "react-i18next";

import ImagePageNavigationControl from "./ImagePageNavigationControl";
import ImageZoomControl from "./ImageZoomControl";
import { Icon, Icons } from "../../components/Icon";
import { BaseTooltip } from "../../components/Tooltip/BaseTooltip";
import { MAX_ZOOM_RATIO, MIN_ZOOM_RATIO } from "../../constants/ImageScale";
import { cn } from "../../utils/style";

export interface ImageViewToolbarProps {
  fileVisible: boolean;
  imageScale: number;
  onImageScaleChange: (scale: number) => void;
  numberOfImages: number;
  page: number;
  onPageSelect: (index: number) => void;
  onRotate?(): void;
  onReset?(): void;
}

export function ImageViewToolbar({
  fileVisible,
  imageScale,
  onImageScaleChange,
  numberOfImages: pageSize,
  page: pageIdx,
  onPageSelect,
  onRotate,
  onReset,
}: ImageViewToolbarProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "absolute bottom-0 z-10 flex h-footer w-full items-center justify-center bg-muted px-4 mobile:h-mobile-footer",
        {
          invisible: !fileVisible,
        },
      )}
    >
      <div className="flex w-full items-center justify-between">
        {/* 회전 및 화면 크기 초기화 버튼*/}
        <div className="flex rounded-lg border border-border">
          <BaseTooltip tooltipContent={<div>{t(`actions.rotate`)}</div>}>
            <Button variant="ghost" size="icon" onClick={onRotate}>
              <Icon source={Icons.Rotate} />
            </Button>
          </BaseTooltip>

          <BaseTooltip tooltipContent={<div>{t(`actions.fit_to_screen`)}</div>}>
            <Button variant="ghost" size="icon" onClick={onReset}>
              <ArrowsPointingOutIcon className="size-5" />
            </Button>
          </BaseTooltip>
        </div>

        {/* 확대 및 축소 버튼 */}
        <div className="w-full max-w-[170px] mobile:mx-4">
          <ImageZoomControl
            imageScale={imageScale}
            onClickZoomIn={() => {
              if (imageScale * 1.1 < MAX_ZOOM_RATIO) {
                onImageScaleChange(imageScale * 1.1);
              }
            }}
            onClickZoomOut={() => {
              if (imageScale * 0.9 > MIN_ZOOM_RATIO) {
                onImageScaleChange(imageScale * 0.9);
              }
            }}
            onImageHandler={onImageScaleChange}
          />
        </div>

        {/* 페이지 이동 버튼 */}
        <ImagePageNavigationControl
          pageIdx={pageIdx}
          pageSize={pageSize}
          onPageSelect={onPageSelect}
          onReset={onReset}
        />
      </div>
    </div>
  );
}
